import {
  GET_DIET,
  CREATE_DIET,
  UPDATE_DIET,
  DELETE_DIET,
  axios,
  baseURL,
} from "./types";

// Helper: loginData se automatic token aur hospitalID nikalne ke liye
const getLoginDetails = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return {
    token: loginData.token || '',
    hospitalID: loginData.hospitalID || '' 
  };
};

// 1. GET ALL
export const getDiet = () => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  return axios({
    method: "post",
    url: `${baseURL}/api/appointmentDietPlan/getall`,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    data: { hospitalID: hospitalID },
  })
  .then((res) => {
    dispatch({ type: GET_DIET, payload: res.data, hospitalID: hospitalID });
    return res;
  })
  .catch((err) => { throw err });
};

// 2. CREATE
export const createDiet = (formData) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  return axios({
    method: "post",
    url: `${baseURL}/api/appointmentDietPlan/create`,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    data: { ...formData, hospitalID: hospitalID },
  })
  .then((res) => {
    dispatch({ type: CREATE_DIET, payload: res.data });
    return res;
  })
  .catch((err) => { throw err });
};

// 3. UPDATE
export const updateDiet = (formData) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  return axios({
    method: "patch",
    url: `${baseURL}/api/appointmentDietPlan/update`,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    data: { ...formData, hospitalID: hospitalID },
  })
  .then((res) => {
    dispatch({ type: UPDATE_DIET, payload: res.data });
    return res;
  })
  .catch((err) => { throw err });
};

// 4. DELETE
export const deleteDiet = (data) => (dispatch) => {
  const { token, hospitalID } = getLoginDetails();
  return axios({
    method: "delete",
    url: `${baseURL}/api/appointmentDietPlan/delete`,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    data: { ...data, hospitalID: hospitalID },
  })
  .then((res) => {
    dispatch({ type: DELETE_DIET, payload: res.data });
    return res;
  })
  .catch((err) => { throw err });
};